import { render, staticRenderFns } from "./lrDialog.vue?vue&type=template&id=483cf621"
import script from "./lrDialog.vue?vue&type=script&lang=js"
export * from "./lrDialog.vue?vue&type=script&lang=js"
import style0 from "./lrDialog.vue?vue&type=style&index=0&id=483cf621&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports